import { ElementRef, EventEmitter, Output, ViewChild, Directive } from '@angular/core';
import { OfferModalEvent } from 'smartauction-frontend-micro-library';
import { OfferHistory } from '../../models/offer-history.model';
import { OfferModalItem } from '../../../shared/models/offer-modal-item.model';
import { BidInventoryItem, FinanceSource } from 'remarketing-angular-library';
import { BuyFee } from 'remarketing-angular-library/interfaces/buy-fee';

@Directive()
export class OfferModalAction {
  modalId: string;
  tenantName: string;
  item: OfferModalItem;
  offerHistory: OfferHistory[];
  bidItem: BidInventoryItem;
  /**
   * The listing's fee schedule, for the all-in price breakdown (M4.4, drip pricing).
   *
   * A narrow BuyFee rather than a second whole item, and separate from bidItem, because OfferModalsComponent
   * populates it from two sources whose types are unrelated: bidItem (BidInventoryItem) when the host was
   * given one, and otherwise the getBidListItem response (BidItem). The two interfaces share buyFee and
   * little else, so widening bidItem to cover both would need a cast and would hand the counter-offer
   * modal -- which reads bidItem directly -- an object it does not expect. buyFee is all any offer action
   * needs for the breakdown.
   */
  buyFee: BuyFee;
  financeSource: FinanceSource;
  showWarning: boolean;
  errorMessage: string | ((val: string | number) => string);
  waitingResponse = false;
  successfulResponse = false;

  @ViewChild('error') errorRef: ElementRef<HTMLParagraphElement>;
  @Output() event = new EventEmitter<OfferModalEvent>();

  setError(errorMessage: string) {
    this.errorMessage = errorMessage;
    setTimeout(() => {
      if (this.errorRef) {
        this.errorRef.nativeElement.focus();
      }
    });
  }
}
